/**
 * 見出しの右の短い状態「見守り中 · 声 入」「確認が 1 件」「止めています」（ADR-0055）。DOM を持たない部分。
 * 色は 2 つだけ: 琥珀 = 本人の判断待ち（承認・止めてある）、緑 = ふだん。事実は全て他の読み込み（承認・見張り役）から。
 */
export interface StatusInput {
  /** 承認待ちの数（読めなければ null） */
  pending_approvals: number | null;
  /** 提案・権限の申請の答え待ちの数（ADR-0060。読めなければ null・省略） */
  pending_proposals?: number | null;
  /** 凍結中か（読めなければ null） */
  frozen: boolean | null;
  /** 見張り役が止まっているか */
  monitor_down: boolean;
  /** 読み上げの入・切 */
  speak_on: boolean;
}

export type StatusTone = "ok" | "amber";

export interface StatusLine {
  text: string;
  tone: StatusTone;
}

export function statusLine(s: StatusInput): StatusLine {
  if (s.frozen) return { text: "止めています（凍結中）", tone: "amber" };
  const waiting = (s.pending_approvals ?? 0) + (s.pending_proposals ?? 0);
  if (waiting > 0) return { text: `確認が ${waiting} 件`, tone: "amber" };
  const voice = s.speak_on ? "声 入" : "声 切";
  if (s.monitor_down) return { text: `見張り役が止まっています · ${voice}`, tone: "amber" };
  return { text: `見守り中 · ${voice}`, tone: "ok" };
}
